import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { IWarhouseListItem } from '../../../modules/API/Defaults/models/warhouseList';
import WarehouseIcon from '../../icons/IconLib/WarehouseIcon';

interface Props {
    warehouses: IWarhouseListItem[];
    value: IWarhouseListItem | null;
    onSelect: (warehouse: IWarhouseListItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    allowClear?: boolean;
    clearLabel?: string;
    className?: string;
}

const WarehouseSelector: React.FC<Props> = ({
    warehouses,
    value,
    onSelect,
    placeholder,
    disabled,
    readOnly,
    allowClear,
    clearLabel,
    className,
}) => {
    const [t] = useTranslation('selectors');

    return (
        <SearchableSelect<IWarhouseListItem>
            items={warehouses}
            value={value}
            onSelect={onSelect}
            getKey={(w) => w.WarehouseID}
            getLabel={(w) => (w.WarehouseDesc ?? '').trim()}
            placeholder={placeholder ?? t('selectors_warehouse_placeholder')}
            disabled={disabled}
            readOnly={readOnly}
            allowClear={allowClear}
            clearLabel={clearLabel ?? t('selectors_clear')}
            leadingIcon={<WarehouseIcon />}
            className={className}
            emptyLabel={t('selectors_warehouse_empty')}
        />
    );
};

export default WarehouseSelector;
